export default __webpack_public_path__ + "static/media/screen4.66486bcb.png";